/**
 * Pulse-Security Fixture.
 */

const NOW = Date.now();

const ALERTS = [
  {
    id: 1,
    severity: 'critical',
    title: 'CrowdSec: IP gebannt (ssh-bf)',
    message: '203.0.113.42 — 12 fehlgeschlagene SSH-Logins/min',
    source: 'crowdsec',
    service_id: null,
    tenant_id: null,
    hostname: 'core-prod-1',
    created_at: new Date(NOW - 5 * 60_000).toISOString(),
    acknowledged_at: null,
    resolved_at: null,
  },
  {
    id: 2,
    severity: 'high',
    title: 'Zabbix: Disk-Pressure',
    message: 'Node dev-a0001: verfügbarer Speicher < 10%',
    source: 'zabbix',
    service_id: null,
    tenant_id: null,
    hostname: 'dev-a0001',
    created_at: new Date(NOW - 40 * 60_000).toISOString(),
    acknowledged_at: new Date(NOW - 35 * 60_000).toISOString(),
    resolved_at: new Date(NOW - 20 * 60_000).toISOString(),
  },
];

const EVENTS = [
  { id: 101, source: 'core', event_type: 'auth.login_failed', severity: 'medium', created_at: new Date(NOW - 2 * 60_000).toISOString(), ip: '198.51.100.7', metadata: { reason: 'bad_password' } },
  { id: 102, source: 'nexus', event_type: 'auth.m2m_invalid', severity: 'high', created_at: new Date(NOW - 15 * 60_000).toISOString(), ip: '198.51.100.9', metadata: { path: '/v1/admin/plugins' } },
  { id: 103, source: 'orbit', event_type: 'auth.permission_denied', severity: 'medium', created_at: new Date(NOW - 60 * 60_000).toISOString(), ip: '198.51.100.3', metadata: { requiredPerms: ['integrations.write'] } },
];

const DECISIONS = [
  { id: '1', origin: 'crowdsec', scenario: 'crowdsecurity/ssh-bf', type: 'ban', scope: 'ip', value: '203.0.113.42', duration: '4h', untilAt: new Date(NOW + 3 * 3600_000).toISOString(), source: 'cscli', firstSeenAt: new Date(NOW - 5 * 60_000).toISOString(), lastSeenAt: new Date(NOW - 5 * 60_000).toISOString(), removedAt: null },
];

export function alertsFixture() {
  return { items: ALERTS, total: ALERTS.length, unacknowledged: ALERTS.filter((a) => !a.acknowledged_at).length };
}
export function eventsFixture() {
  return { items: EVENTS };
}
export function decisionsFixture() {
  return { items: DECISIONS };
}
